import { PageTitle } from 'context/PageTitleContext'
import React from 'react'
import { useParams } from 'react-router-dom'
import { BackButton, AddSupervisor } from 'components'
import './Add.scss'

export default function CreateSuperVisor() {
  const { companyId } = useParams()

  return (
    <div className="create-supervisor">
      <PageTitle title="Company Profile" />
      <BackButton />
      <AddSupervisor companyId={companyId} />
    </div>
  )
}
